import { render, staticRenderFns } from "./BenefitHubLandingPage.vue?vue&type=template&id=e61b4a34"
import script from "./BenefitHubLandingPage.vue?vue&type=script&lang=js"
export * from "./BenefitHubLandingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports